<template>
  <div class="login">
    <div class="login_box">
      <div class="inputs custom_card">
        <div class="card-header">
          <div class="log-img mb-5">
            <img src="@/assets/images/icons/logo.png" width="250" height="80" />
          </div>
          <h4 class="mt-4">{{ $t("auth.title") }}</h4>
          <p>{{ $t("auth.desc") }}</p>
        </div>

        <form class="form form-horizontal" @submit.prevent="validateLoginForm">
          <div class="form-body">
            <div class="row">
              <div class="col-12">
                <!-- START:: EMAIL INPUT -->
                <div class="input_wrapper animated_placeholder">
                  <input-phone
                    @changeKey="phoneKeyChanged"
                    :placeholder="$t('labels.phone')"
                    :preSelectedPhoneCode="data.phone.key"
                    v-model="data.phone.number"
                    class="w-100"
                  ></input-phone>
                </div>
                <!-- END:: EMAIL INPUT -->

                <!-- START:: PASSWORD INPUT -->
                <div class="input_wrapper animated_placeholder">
                  <button
                    type="button"
                    class="toggle_pass_btn"
                    @click="helper_togglePasswordVisibility"
                  >
                    <i class="fal fa-eye open_eye"></i>
                    <i class="fal fa-eye-slash closed_eye"></i>
                  </button>
                  <input
                    type="password"
                    class="form-control"
                    :placeholder="$t('forms.labels.password')"
                    v-model.trim="data.password"
                    @input="helper_checkIfInputIsEmpty"
                  />
                  <label for="login_pass" class="form-label">
                    {{ $t("forms.labels.password") }}
                  </label>
                </div>
                <!-- END:: PASSWORD INPUT -->
              </div>
            </div>
          </div>

          <div class="buttons_wrapper">
            <button class="button_style_1">
              {{ $t("forms.login") }}
              <span class="btn_loader" v-if="btnIsLoading"></span>
            </button>
          </div>
        </form>
      </div>

      <!-- Image Side -->
      <div class="image">
        <img src="@/assets/images/pages/login/women.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import InputPhone from "@/components/Forms/InputPhone.vue";
export default {
  components: { InputPhone },
  data() {
    return {
      // Loading
      btnIsLoading: false,

      data: {
        email: null,
        password: null,

        phone: {
          number: null,
          key: null,
          id: null,
          limit: null,
        },
      },
    };
  },

  methods: {
    launch_resize_dispatch() {
      this.$store.dispatch("sideNav_module/onResize");
    },

    validateLoginForm() {
      this.btnIsLoading = true;

      if (!this.data.phone.number) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.phone"),
          position: "bottomCenter",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.password) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.password"),
          position: "bottomCenter",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitLoginForm();
      }
    },

    submitLoginForm() {
      this.$axios({
        method: "post",
        url: "login",
        data: {
          country_id: this.data.phone.id,
          phone: this.data.phone.number,
          password: this.data.password,
        },
      })
        .then((res) => {
          const data = {
            userId: res.data.data.id,
            token: res.data.data.token,
            userImage: res.data.data.avatar,
            userPhone: res.data.data.phone,
            // userType: res.data.data.user_type,
          };

          this.$store.dispatch("auth_module/logIn", data);

          this.$iziToast.success({
            timeout: 2000,
            message: res.data.messages || res.data.message,
            position: "bottomRight",
          });

          this.btnIsLoading = false;
        })
        .catch((err) => {
          const message =
            err.response?.data?.messages ||
            err.response?.data?.message ||
            this.$t("forms.validation.password");
          this.$iziToast.error({
            timeout: 2000,
            message: message,
            position: "bottomRight",
          });

          this.btnIsLoading = false;
        });
    },
    phoneKeyChanged(data) {
      this.data.phone.key = data.key;
      this.data.phone.limit = data.limit;
      this.data.phone.id = data.id;
    },
  },

  mounted() {
    if (this.$store.getters.resizeEventExisit == true) {
      window.removeEventListener("resize", this.launch_resize_dispatch, true);
      this.$store.commit("changeRessizeEvent");
    }

    document.querySelector("body").style.padding = "0 !important";
  },
};
</script>
